import { Button, Flex, List, Popconfirm, PopconfirmProps } from "antd";
import { observer } from "mobx-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import Subjects from "../../models/subjects";
import StudentItemStore, { StudentTicketStore } from "../../stores/students/student-item";

const StudentTicketItem: React.FC<{ student: StudentItemStore, subject: Subjects, item: StudentTicketStore, indx: number }> = ({ student, subject, item, indx }) => {

    const navigate = useNavigate();

    const onConfirm: PopconfirmProps['onConfirm'] = (e) => {
        student.unassign(item.data.id);
    };

    const backgroundColor = (indx % 2) ? "#f0f0f0" : "";

    return <List.Item key={item.data.id} style={{ backgroundColor: backgroundColor }}
        extra={
            <Flex align="flex-start" gap="small" vertical>
                <Button
                    type="link"
                    onClick={() => navigate(`/${subject.toLowerCase()}/students/${student.data.id}/tickets/${item.data.ticketId}`)}
                >Редактировать ответы</Button>
                <Popconfirm
                    title="Удалить проверку"
                    description="Вы уверены, что хотите удалить проверку? Отменить это действие будет невозможно"
                    onConfirm={onConfirm}
                    okText="Да"
                    cancelText="Нет"
                >
                    <Button type='link' danger>Удалить проверку</Button>
                </Popconfirm>
            </Flex>
        }
    >
        <List.Item.Meta
            title={`Вариант ${item.data.ticketId}. Проверен ${new Date(item.data.completeDate).toLocaleString()}. Баллов ${item.data.pointsSum}`}
        />
    </List.Item>
}

export default observer(StudentTicketItem);